export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.template': '模板示例',
  'menu.reimbursements': '报销管理',
  'menu.reimbursements.dashboard': '工作台',
  'menu.reimbursements.invoices': '发票采集',
  'menu.reimbursements.invoices.my': '我的发票',
  'menu.reimbursements.invoices.all': '全部发票',
  'menu.reimbursements.claims': '报销单',
  'menu.reimbursements.claims.my': '我的报销单',
  'menu.reimbursements.claims.all': '全部报销单',
  'menu.reimbursements.approval': '审批中心',
  'menu.reimbursements.approvalDetail': '审批详情',
  'menu.reimbursements.claimEdit': '填写报销单',
  'menu.reimbursements.analytics': '统计分析',
  'menu.reimbursements.myAnalytics': '我的统计',
  'menu.reimbursements.managementCockpit': '管理统计',
  'menu.reimbursements.financeAnalytics': '财务统计',
  'menu.reimbursements.specialAnalytics': '财务统计',
  'menu.reimbursements.analytics.reimbursements.myAnalytics': '我的统计',
  'menu.reimbursements.analytics.reimbursements.financeAnalytics': '财务统计',
  'menu.reimbursements.analytics.reimbursements.managementCockpit': '管理统计',
  'menu.settings': '设置',
  'menu.settings.reimbursement': '报销设置',
  'menu.settings.anomalyRules': '异常规则',
  'menu.settings.buyers': '购买方设置',
  'menu.settings.expenseCategories': '费用类型',
  'menu.settings.sceneTemplates': '场景模板',
  'menu.settings.personalQuotaConfigs': '个人额度',
  'menu.settings.expenseStandardPolicies': '费用标准',
  'menu.settings.permissions': '权限管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
